export default {
    ADDITIONAL_CONTROL_TYPE: "Additional control",
    AGE_TYPE: "Age",
    DEVIATION_REASON: "Reason for deviation",
    CARGO_CONDITION: "Cargo condition",
    BUSINESS_OPERATION: "Operation of business process",
    BUSINESS_PROCESS: "Business process",
    CLASS_ACCESS_DOCS: "Permitting document",
    CLASS_ACCESS_DOCS_FROM_PART_NUMBER_POSITION: "Permitting document",
    CLASS_ACCESS_DOCS_TYPE: "Code of permitting doc",
    CLASS_ACCESS_DOCS_TYPE_COUNT_44: "Name, data of permitting doc (graph 44)",
    COLOR: "Color",
    COMPANY_CRM: "Inquiry",
    COMPANY_CRM_EVENT: "CMR event",
    COMPANY_CRM_EVENT_CONNECTION_TYPE: "Type of connection",
    COMPANY_CRM_EVENT_IMPORTANT: "Priority",
    COMPANY_CRM_EVENT_TYPE: "Event type",
    COMPANY_CRM_STATUS: "Status",
    COMPANY_CRM_TYPE_REQUEST: "Inquiry type",
    COMPANY_DOC_NUMBER_MASK: "Number patterns",
    COMPANY_GTD_BALANCE: "Balance",
    CONTRACTS_ADDITION: "Supplementary agreements",
    CONTRACTS_ADDITION_TYPE: "Types of supplementary agreements",
    CONTRACTS_FEA: "FEA contract",
    ORDER_REQUEST_CURRENCY_TRANSLATION: "Foreign currency transactions",
    CONTRACTS_FEA_ADDITION: "Additional agreement",
    CONTRACTS_MATH_DETAILS: "Details of the calculations",
    CONTRACTS_PAYMENT_TYPE: "Payment",
    CONTRACTS_RELATION_TYPE: "Type of relationship",
    CONTRACTS_STATUS: "Status",
    COURIER: "Courier",
    CRM_REQUEST_SOURCE: "Source of inquiry",
    CURRENT_USER_TASK: "Tasks",
    DATA_CHANGES_LOG_YUNAS: "Load XML Yunas",
    DEPARTMENT: "Departments",
    DOCUMENT_MANAGEMENT: "Document",
    DOCUMENT_MANAGEMENT_DOC_TYPE: "Document type ",
    DOC_OPERATION: "Documentary operation",
    DOC_OPERATION_TYPE: "Type of documentary operations",
    DOC_OPERATION_UNIT_LINK: "Documentary operation",
    EFFEX_EVENTS_UNIT: "Effex event",
    FIN_OPERATION: "Fin.operations",
    FIN_OPERATION_SALE: "Fin.transactions sale",
    FIN_OPERATION_SALE_EASTEX: "Fin.transactions sale",
    FIN_OPERATION_BUY: "Fin.transactions purchase",
    FIN_OPERATION_BUY_EASTEX: "Fin.transactions purchase",
    FIN_OPERATION_BY_UNIT: "Financial scheme",
    FIN_OPERATION_DETAIL_TYPE: "Type of service item detailing",
    FIN_OPERATION_GROUP_UNIT: "Cargo places",
    FIN_OPERATION_TYPE: "Type of financial operation",
    FIN_OPERATION_ORDER_DOC_LINK: "Fin. operations docs",
    GTD_ADDITIONAL_CHECK: "Additional verifications and Customs Value Correction",
    GTD_ADDITIONAL_CHECK_STATUS: "Statuses of desisions of additional verifications",
    GTD_RESULT_RETURNING_OTP_STATUS: "Statuses of results of verifications by Customs",
    GTD_ADDITIONAL_CHECK_TYPE: "Type of customs verification",
    GTD_FACT_TYPE: "Declaration type",
    GTD_MODE: "Customs mode",
    GU_FORM_STATUS: "Status GU",
    INSTRUCTION_EXECUTOR_TYPE: "Type of user (execution)",
    INVOICE: "Invoices",
    INVOICE_INCOMING: "Incoming invoices",
    INVOICE_INCOMING_MONEY: "Incoming cash",
    INVOICE_OUTGOING: "Outgoing invoices",
    INVOICE_OUTGOING_MONEY: "Cash expenses",
    INVOICE_POSITIONS: "Invoice positions",
    INVOICE_TYPE: "Invoice type",
    LIST_ACTIVE_GTD: "Current GDs",
    LIST_ADDRESS_COMPANY: "Address",
    LIST_AIRPORTS: "Airports",
    LIST_ALL_GTD: "Declaration (All)",
    LIST_ARCHIVE_GTD: "GDs in the archive",
    LIST_AUTO: "Vehicles",
    LIST_BANKS: "Banks",
    LIST_CITY: "Cities",
    LIST_CLASSIFICATION: "Classificatory register",
    LIST_CLASSIFICATION_UPDATE: "Update of the classification Handbook",
    LIST_CLASS_DANGER: "Danger classes",
    LIST_COMPANY: "Counterparties",
    LIST_COMPANY_BANKS: "Counterparties banks",
    LIST_COMPANY_BANK_ACCOUNTS: "Bank accounts",
    LIST_COMPANY_CONTACT_PERSONS: "Contact persons",
    LIST_COMPANY_GROUPS: "Group of companies",
    LIST_COMPANY_LIFE_CYCLE: "Company's life cycle",
    LIST_COMPANY_MARKS: "Company's mark",
    LIST_CONTACT_PERSONS: "Contact persons",
    LIST_CONTACT_PERSONS_DATA: "Contact info",
    LIST_CONTRACTS: "Contracts",
    LIST_COUNTRY: "Counties",
    LIST_CURS: "Exchange rates",
    LIST_CURS_INTERNAL: "Exchange rates",
    LIST_CUSTOMS_INSPECTORS: "Inspectors",
    LIST_DELIVERY_CONDITIONS: "Incoterms",
    LIST_DOCUMENTS: "Documents",
    LIST_DRIVERS: "Drivers",
    LIST_ETSNG: "ETSNG",
    LIST_FEACC_GTD: "GD goods",
    LIST_FEACC_ARTICLE: "Articles of Declaration",
    LIST_GNG: "The harmonized nomenclature of goods",
    LIST_GTD: "Declarations",
    LIST_HOOK: "Hooks",
    LIST_NAME_WEIGHT: "Cargo name",
    LIST_NAVALPORTS: "Marine ports",
    LIST_ORDER_POSITIONS: "Order positions",
    LIST_PERSON_POST: "Employee's position",
    LIST_POST_CUSTOMS_GTD: "Refunds for additional verification",
    LIST_RAILWAYS: "Railroads",
    LIST_REGION: "Regions",
    LIST_RUR_EQUIV: "Re-evaluation log",
    LIST_TNVED: "Commodity nomenclature of foreign economic activities",
    LIST_TYPE_ACCOUNT: "Account types",
    LIST_TYPE_CONTRACTS: "Contract names",
    LIST_TYPE_DOCUMENT: "Document types",
    LIST_TYPE_FEACC_DOCUMENTS: "Documents for customs declations",
    LIST_TYPE_FLAT: "room type",
    LIST_TYPE_LINK: "Address type",
    LIST_TYPE_MODEL_AUTO: "Vehicle brands",
    LIST_TYPE_MODEL_HOOK: "Hook brands",
    LIST_TYPE_VAN: "Hook type",
    LIST_USER: "User accounts",
    LIST_VAT: "with VAT/without VAT",
    LIST_WAREHOUSE: "Route stops",
    LIST_WAREHOUSES_COMPANY_LINK: "Company's warehouses",
    LIST_WAREHOUSES_ROLES_LINK: "Route stops roles",
    LIST_WAREHOUSE_WAREHOUSES_LINK: "Route stops",
    LOGISTAS_UNIT: "Goods",
    MATERIAL: "Material",
    OPERATION: "Operation",
    OPERATION_AIR: "Air",
    OPERATION_ARRIVAL_POINT: "Route",
    OPERATION_AUTO: "Trucking",
    OPERATION_CARGO_STATUS_EX_T1: "The status of the cargo EX/T1",
    OPERATION_CUSTOMS: "Customs clearance",
    OPERATION_DETAIL: "Detailing of operation",
    OPERATION_FORWARD: "Port/terminal forwarding",
    OPERATION_FORWARD_INSPECTION: "Inspections",
    OPERATION_FORWARD_INSPECTION_TYPE: "Type of operation",
    OPERATION_PACKING_UNIT_TYPE: "Units",
    OPERATION_RATE_EXPENSE_INCLUDE: "Detailing of item",
    OPERATION_RATE_EXPENSE_TYPE: "Item",
    OPERATION_SEA: "Sea carriage",
    OPERATION_SUB_DOC: "Document",
    OPERATION_TRAIN: "Rail transportation",
    OPERATION_TYPE: "Types of operations",
    OPERATION_UNIT: "Cargo unit",
    OPERATION_UNIT_DIVISION: "Type of cargo",
    OPERATION_UNIT_SCOPE: "Cargo unit",
    OPERATION_UNIT_TYPE: "Cargo unit type",
    ORDER: "Orders",
    ORDER_DOCS_SCHEME: "Template documentary scheme",
    ORDER_FOR_OWNER_UNIT: "Orders",
    FIN_OPERATION_BY_OWNER_UNIT: "Fin operation by owner unit",
    ORDER_FOR_OWN_ROLLING_STOCK_UNIT: "Orders",
    ORDER_REQUEST: "Commercial offer",
    ORDER_REQUEST_CONTRACT_TYPE: "Type of contract",
    OWNER_UNIT: "Own rolling stock",
    OWN_ROLLING_STOCK_UNIT: "Own rolling stock",
    PART_NUMBER: "Invoice",
    PART_NUMBER_POSITION: "Number of item",
    PAYMENT_DAY_OF_THE_MONTH: "Payment days",
    PAYMENT_DAY_OF_THE_WEEK: "Payment day",
    PAYMENT_ORDERS: "Payments",
    PAYMENT_ORDERS_EXPENCE_TYPE: "Type of expenses",
    PAYMENT_ORDERS_INCOMING: "Incoming payment orders",
    PAYMENT_ORDERS_OUTGOING: "Outgoing payment orders",
    PRODUCTION: "Products",
    PRODUCT_CATEGORY: "Product category",
    PRODUCT_TYPE: "Type of products",
    REMEMBER: "Reminder",
    REMEMBER_TYPE: "The reminder type",
    REQUEST_CURRENCY_TRANSLATION: "Foreign currency transactions",
    REQUEST_CURRENCY_TRANSLATION_TYPE: "Type of application",
    REVALUE_TRANSFER: "Exchange rate re-evaluation",
    SEA_RATES: "Sea quotes",
    SEX: "Floor",
    STORAGE_RATES: "Storage rates",
    SYS_ACL_ROLE: "Access rights",
    SYS_FILES: "Files",
    TRANSFER_DISLOCATION: "Dislocation",
    USER_ADDITIONAL_CREDENTIALS: "Third-party accounts",
    USER_ADDITIONAL_CREDENTIALS_TYPE: "Account type",
    ROLIS_EVENT: "Rolis events",
    ROLIS_SUBSCRIPTION: "Rolis subscription",
    ROLIS_EDI: "Rolis EDI",
    USER_FEEDBACK: "Users messages",
    USER_TASK: "Tasks",
    USER_TASK_IMPORTANCE: "Task importance",
    USER_TASK_STATUS: "Task status",
    USER_TASK_THEME: "Task template",
    USER_TASK_THEME_TO_BUS_OP: "Task template",
    USER_TASK_TYPE: "Task type",
    VESSEL: "Vessels",
    WEIGHT_GROUP: "Group of products",
    WORK_INSTRUCTIONS: "Working instructions",
    WORK_INSTRUCTIONS_CATEGORY: "Working instructions",
    WORK_INSTRUCTIONS_DOCUMENT: "Working instructions",
    WORK_INSTRUCTIONS_TYPE: "Document type",
    OPERATION_RATE_EXPENSE_CATEGORY: "Service item category",
    CRM_REQUEST_STATUS: "Status of inquiry",
    OPERATION_CUSTOM_STATUS: "Status of B/L",
    OPERATION_CUSTOM_STATUS_TYPE: "Directory of B/L statuses",
    REQUEST_GTD: "Application for Customs Declaration",
    TEMPLATE_INVOICE_POST: "Expense template",
    TEMPLATE_INVOICE: "Cash expenses template",
    LIST_CONTACT_PERSONS_EMAIL_BROADCAST_CONFIG: "The pattern of distribution of documents",
    ORDER_NOTIFICATIONS: "Order mailing",
    AUTO_RATES: "Trucking quotes",
    SEA_PORT_EXPENSES: "Local port costs",
    CAPITAL_TRANSFER: "Transactions",
    CAPITAL_ACCOUNT: "Accounts",
    CONTRACTS_FEA_ADDITION_SPECIFICATIONS: "Specification",
    LIST_REUSABLE_CONTAINERS_POSITION: "Reusable tare (items)",
    LIST_REUSABLE_CONTAINERS: "Reusable tare",
    LIST_REUSABLE: "List of reusable tare",
    FEEDBACK_TYPE: "Feed-back",
    PERSON_TO_NOTIFY: "Notify party",
    CAPITAL_CONVERSION_OPERATION: "Foreign exchange operation",
    DOCUMENT_STATUS: "Statuses of docs",
    EDI_EVENT: "EDI events",
    TRAIN: "Trains",
    CRITERIA_TYPE: "Criteria",
    CRITERIA_VALUE: "Value of criteria",
    PAYMENT_ORDERS_GROUP_EXPENCE_TYPE: "Group of expenses",
    PAYMENT_ORDERS_SUBGROUP_EXPENCE_TYPE: "Subgroup of expenses",
    SYSTEM_SYS_LOG: "Logs",
    USER_ROLE: "Roles",
    CHECK_CUSTOM_PAYMENTS_NOTE: "Note",
    DOCS_SEND_METHOD: "way of doc dispatch",
    DECLARATION_UNIT: "Cargo units for inspection",
    CUSTOM_CURRENCY_CURS: "Custom rates",
    LIST_COMPANY_CATEGORY: "Category of counterparty",
    LIST_COMPANY_CATEGORY_GROUP: "Category group",
    COMPANY_STORAGE_RATES: "Storage rates",
    CUSTOM_MODE: "Customs regime",
    PRODUCT: "Job Solution",
    MOVE_TYPE: "Move type",
    BIZ_SCOPE: "BizScope",
    CTRL: "Ctrl/non-ctrl",
    BL_TYPE: "B/L type",
    TEMPLATE_NOTIFICATION_MAILING_DOC: "Templates for docs mailing",
    TEMPLATE_NOTIFICATION_MAILING: "Notifications mailing template",
    DYNAMIC_JOURNALS: "Client logs",
    REPORT_SETTINGS: "Reports settings",
    ICB_OFFICE: "ICB Offices",
    PAYABLE_CSO: "Payable CSO",
    MANAGER_BONUS: "Manager bonuses",
    FIN_OPERATION_BY_OWN_ROLLING_STOCK_UNIT: "Fin operations for own rolling stock unit",
    REASON_BEING_LATE: "Reason for the delay",
    FinancialResultReport: "Financial result detalization",
    COMPANY_ADDITIONAL_INFORMATION: "Additional information",
    LIST_WAREHOUSE_TYPE_ROLE: "Roles",
    RISK_CLASS: "Risk class",
    INDUSTRY: "Industry",
    LIST_OWNERSHIP_TYPE: "Types of ownership",
    CAPITAL_TRANSFER_TEMPLATE: "Templates of accounting entries",
    SERVICE_COMBINATION: "Service combination",
    PAYMENT_SCHEDULE: "Payment schedule",
    GHQ_ACTIVITY: "GHQ Activity",
    TEMPLATE_PAYMENT_SCHEDULE: "Template of PS",
    CONSOL_TYPE: "Consol type",
    BRANCH_YUNAS: "Branch Yunas",
    sample_collection: "Sample collection"
};
